import { LayaGL } from "../../../layagl/LayaGL";
import { Vector3 } from "../../../maths/Vector3";
import { Pool } from "../../../utils/Pool";
import { ShaderDefines2D } from "../../../webgl/shader/d2/ShaderDefines2D";
import { Command2D } from "./Command2D";
export class DrawRenderElement2DCMD extends Command2D {
    static create(element, mat = null) {
        let cmd = DrawRenderElement2DCMD._pool.take();
        cmd.renderElement = element;
        cmd._setMatrix(mat);
        return cmd;
    }
    get renderElement() {
        return this._renderElement;
    }
    set renderElement(value) {
        this._renderElement = value;
        this._drawElementCMDData.setRenderelements([this._renderElement]);
    }
    constructor() {
        super();
        this._drawElementCMDData = LayaGL.render2DRenderPassFactory.createDraw2DElementCMDData();
    }
    _setMatrix(value) {
        value ? (this._matreix = value.clone()) : (this._matreix = null);
        if (this._matreix && this.renderElement.nodeCommonMap && this.renderElement.nodeCommonMap.indexOf("BaseRender2D") != -1) {
            let vec3 = Vector3.TEMP;
            vec3.x = this._matreix.a;
            vec3.y = this._matreix.c;
            vec3.z = this._matreix.tx;
            this._renderElement.value2DShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_0, vec3);
            vec3.x = this._matreix.b;
            vec3.y = this._matreix.d;
            vec3.z = this._matreix.ty;
            this._renderElement.value2DShaderData.setVector3(ShaderDefines2D.UNIFORM_NMATRIX_1, vec3);
        }
    }
    run() {
    }
    recover() {
        super.recover();
        DrawRenderElement2DCMD._pool.recover(this);
    }
    getRenderCMD() {
        return this._drawElementCMDData;
    }
    destroy() {
        this._renderElement = null;
        this._drawElementCMDData = null;
    }
}
DrawRenderElement2DCMD._pool = Pool.createPool(DrawRenderElement2DCMD);
